import {
  FETCH_COMPONENTS_REQUEST,
  FETCH_COMPONENTS_SUCCESS,
  FETCH_COMPONENTS_FAILURE,
  FETCH_COMPONENT_REQUEST,
  FETCH_COMPONENT_SUCCESS,
  FETCH_COMPONENT_FAILURE,
  UPDATE_COMPONENTS_REQUEST,
  UPDATE_COMPONENTS_FAILURE,
  UPDATE_COMPONENTS_SUCCESS,
  DELETE_COMPONENTS_REQUEST,
  DELETE_COMPONENTS_FAILURE,
  DELETE_COMPONENTS_SUCCESS,
  CLEAR_COMPONENT_ERRORS,    // Nouvelles imports
  CLEAR_COMPONENT_SUCCESS,
} from './actionTypes';

const initialState = {
  components: [],
  component: null,
  loadingComponent: false,
  errorComponent: null,
  componentAdded: null
};

const Components = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPONENTS_REQUEST:
      return {
        ...state,
        loadingComponent: true,
        errorComponent: null,
        componentAdded: false
      };
    case FETCH_COMPONENTS_SUCCESS:
      return {
        ...state,
        loadingComponent: false,
        components: action.payload,
      };
    case FETCH_COMPONENTS_FAILURE:
      return {
        ...state,
        loadingComponent: false,
        errorComponent: action.payload,
      };
    case FETCH_COMPONENT_REQUEST:
      return {
        ...state,
        loadingComponent: true,
        errorComponent: null,
        componentAdded: false
      };
    case FETCH_COMPONENT_SUCCESS:
      return {
        ...state,
        loadingComponent: false,
        component: action.payload,
      };
    case FETCH_COMPONENT_FAILURE:
      return {
        ...state,
        loadingComponent: false,
        errorComponent: action.payload,
      };
    case UPDATE_COMPONENTS_REQUEST:
      return {
        ...state,
        loadingComponent: true,
        errorComponent: null,
        componentAdded: false
      };
    case UPDATE_COMPONENTS_SUCCESS:
      return {
        ...state,
        loadingComponent: false,
        component: null,
        componentAdded: true
      };
    case UPDATE_COMPONENTS_FAILURE:
      return {
        ...state,
        loadingComponent: false,
        errorComponent: action.payload,
      };
    case DELETE_COMPONENTS_REQUEST:
      return {
        ...state,
        loadingComponent: true,
        errorComponent: null,
        componentAdded: false
      };
    case DELETE_COMPONENTS_SUCCESS:
      return {
        ...state,
        componentAdded: true,
        loadingComponent: false,
        components: state.components.filter(component => component.id !== action.payload),
      };
    case DELETE_COMPONENTS_FAILURE:
      return {
        ...state,
        loadingComponent: false,
        errorComponent: action.payload,
      };
    case CLEAR_COMPONENT_ERRORS:
      return {
        ...state,
        errorComponent: null,
      };
    case CLEAR_COMPONENT_SUCCESS:
      return {
        ...state,
        componentAdded: null,
      };
      
    default:
      return state;
  }
};

export default Components;